/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import EditCategory from "cruds/category-management/edit-category";
import NewCategory from "cruds/category-management/new-category";
import EditItem from "cruds/item-management/edit-item";
import NewItem from "cruds/item-management/new-item";
import EditRole from "cruds/role-managament/edit-role";
import NewRole from "cruds/role-managament/new-role";
import EditTag from "cruds/tag-management/edit-tag";
import NewTag from "cruds/tag-management/new-tag";
import EditUser from "cruds/user-management/edit-user";
import NewUser from "cruds/user-management/new-user";
import EditPersona from "cruds/persona-management/edit-persona";
import NewPersona from "cruds/persona-management/new-persona";
import CourseContent from "layouts/pages/course-content";
import ExpandedJob from "cruds/jobs-dashboard/expanded-job";
import VisitedJob from "cruds/jobs-dashboard/visited-job";
import PublicProfile from "layouts/pages/profile/profile-overview/public-profile";
import DealInformation from "layouts/pages/deals/components/DealInformation";
import PublicCourseContent from "layouts/pages/PublicCourseContent";
/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 PRO React layouts

const crudRoutes = [
  {
    key: "new-category",
    route: "/category-management/new-category",
    component: <NewCategory />,
    type: "cateogories",
  },
  {
    key: "edit-category",
    route: "/category-management/edit-category/:id",
    component: <EditCategory />,
    type: "cateogories",
  },
  {
    key: "new-tag",
    route: "/tag-management/new-tag",
    component: <NewTag />,
    type: "tags",
  },
  {
    key: "edit-tag",
    route: "/tag-management/edit-tag/:id",
    component: <EditTag />,
    type: "tags",
  },
  {
    key: "new-role",
    route: "/role-management/new-role",
    component: <NewRole />,
    type: "roles",
  },
  {
    key: "edit-role",
    route: "/role-management/edit-role/:id",
    component: <EditRole />,
    type: "roles",
  },
  {
    key: "new-user",
    route: "/user-management/new-user",
    component: <NewUser />,
    type: "users",
  },
  {
    key: "edit-user",
    route: "/user-management/edit-user/:id",
    component: <EditUser />,
    type: "users",
  },
  {
    key: "new-item",
    route: "/item-management/new-item",
    component: <NewItem />,
    type: "items",
  },
  {
    key: "edit-item",
    route: "/item-management/edit-item/:id",
    component: <EditItem />,
    type: "items",
  },
  {
    key: "new-persona",
    route: "/persona-management/new-persona",
    component: <NewPersona />,
    type: "personas",
  },
  {
    key: "edit-persona",
    route: "/persona-management/edit-persona/:id",
    component: <EditPersona />,
    type: "personas",
  },
  {
    key: "expanded-job",
    route: "/jobs-dashboard/expanded-job/:job_id",
    component: <ExpandedJob />,
    type: "jobs",
  },
  {
    key: "visited-job",
    route: "/jobs-dashboard/visited-job/:job_id",
    component: <VisitedJob />,
    type: "jobs",
  },
  {
    key: "deal-information",
    route: "/deal-information/:id",
    component: <DealInformation />,
    type: "deals",
  },
  {
    key: "course-content",
    route: "/course-content/:course_id",
    component: <CourseContent />,
    type: "course-content",
  },
  {
    key: "course-information",
    route: "/course-information/:course_id",
    component: <PublicCourseContent />,
    type: "course-content",
  },
  // {
  //   key: "public-profile",
  //   route: "/public-profile/:user_id",
  //   component: <PublicProfile />,
  //   type: "profile",
  // },
];

export default crudRoutes;
